import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { AutoCompletePropertiesType } from "@website/ui/auto-complete/auto-complete.types";
import { Button } from "@website/ui/button";
import { ChangeEvent, MouseEvent, useState } from "react";
export const useStart = properties => {
  const $ = _c(52);
  const {
    parts,
    size,
    hideStartIcon,
    disabled
  } = properties;
  const [isOpenStartPopover, setIsOpenStartPopover] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsOpenStartPopover(false);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onCloseStartPopover = t0;
  let t1;
  if ($[1] !== parts[0]?.disabled) {
    t1 = () => {
      !parts[0]?.disabled && setIsOpenStartPopover(true);
    };
    $[1] = parts[0]?.disabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onClickStartTextField = t1;
  let t2;
  if ($[3] !== parts[0]) {
    t2 = event => {
      parts[0]?.onChangeQuery && parts[0]?.onChangeQuery(event.target.value);
    };
    $[3] = parts[0];
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onChangeStartPopoverTextField = t2;
  let t3;
  if ($[5] !== parts[0]) {
    t3 = item => {
      parts[0]?.onSelect && parts[0]?.onSelect(item.id);
      setIsOpenStartPopover(false);
    };
    $[5] = parts[0];
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const onClickStartItem = t3;
  let t4;
  if ($[7] !== parts[0]) {
    t4 = event_0 => {
      event_0.stopPropagation();
      parts[0]?.onChangeQuery && parts[0]?.onChangeQuery("");
    };
    $[7] = parts[0];
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const onEmptyStartSearchField = t4;
  let t5;
  if ($[9] !== parts[0]) {
    t5 = item_0 => {
      parts[0]?.onSelectHistory && parts[0]?.onSelectHistory(item_0.id);
      setIsOpenStartPopover(false);
    };
    $[9] = parts[0];
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const onClickHistoryItem = t5;
  const t6 = parts[0]?.text ? parts[0]?.label : "";
  const t7 = parts[0]?.text;
  const t8 = parts[0]?.label;
  let t9;
  if ($[11] !== hideStartIcon || $[12] !== parts[0]?.StartIcon) {
    t9 = (!hideStartIcon && parts[0]?.StartIcon) ?? <MaterialIcon name="location_on" variant="fill" />;
    $[11] = hideStartIcon;
    $[12] = parts[0]?.StartIcon;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = parts[0]?.disabled;
  const t11 = parts[0]?.helperText;
  let t12;
  if ($[14] !== onClickStartTextField || $[15] !== size || $[16] !== t10 || $[17] !== t11 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t12 = {
      size,
      label: t6,
      value: t7,
      readOnly: true,
      placeholder: t8,
      onClick: onClickStartTextField,
      StartIcon: t9,
      disabled: t10,
      helperText: t11,
      className: "mb-4"
    };
    $[14] = onClickStartTextField;
    $[15] = size;
    $[16] = t10;
    $[17] = t11;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = isOpenStartPopover && !disabled;
  let t14;
  if ($[23] !== t13) {
    t14 = {
      animate: "bottom" as const,
      open: t13,
      onClose: onCloseStartPopover,
      position: "start" as const
    };
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Button EndIcon={<MaterialIcon name="arrow_forward" variant="outlined" />} color="neutral" equalDimension={true} onClick={onCloseStartPopover} type="button" variant="text" />;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = `جستجوی ${parts[0]?.label}`;
  let t17;
  if ($[26] !== t16) {
    t17 = {
      StartAction: t15,
      title: t16
    };
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  const t18 = `جستجوی ${parts[0]?.label}`;
  const t19 = parts[0]?.query;
  let t20;
  if ($[28] !== parts[0]?.StartIcon) {
    t20 = parts[0]?.StartIcon ?? <MaterialIcon name="location_on" variant="outlined" />;
    $[28] = parts[0]?.StartIcon;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== parts[0]?.query) {
    t21 = parts[0]?.query ? <MaterialIcon name="clear" variant="outlined" /> : <MaterialIcon name="search" variant="outlined" />;
    $[30] = parts[0]?.query;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  const t22 = parts[0]?.query ? onEmptyStartSearchField : undefined;
  let t23;
  if ($[32] !== onChangeStartPopoverTextField || $[33] !== t18 || $[34] !== t19 || $[35] !== t20 || $[36] !== t21 || $[37] !== t22) {
    t23 = {
      autoFocus: true,
      placeholder: t18,
      fullWidth: true,
      onChange: onChangeStartPopoverTextField,
      value: t19,
      StartIcon: t20,
      EndIcon: t21,
      onEndIconClick: t22
    };
    $[32] = onChangeStartPopoverTextField;
    $[33] = t18;
    $[34] = t19;
    $[35] = t20;
    $[36] = t21;
    $[37] = t22;
    $[38] = t23;
  } else {
    t23 = $[38];
  }
  let t24;
  if ($[39] !== onClickStartItem || $[40] !== parts[0]?.list) {
    t24 = parts[0]?.list?.map(item_1 => ({
      ...item_1,
      role: "button",
      size: "large",
      onClick: () => onClickStartItem(item_1)
    })) || [];
    $[39] = onClickStartItem;
    $[40] = parts[0]?.list;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== onClickHistoryItem || $[43] !== parts[0]?.historyList) {
    t25 = parts[0]?.historyList?.map(item_2 => ({
      ...item_2,
      role: "button",
      size: "large",
      onClick: () => onClickHistoryItem(item_2)
    })) || [];
    $[42] = onClickHistoryItem;
    $[43] = parts[0]?.historyList;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] !== t12 || $[46] !== t14 || $[47] !== t17 || $[48] !== t23 || $[49] !== t24 || $[50] !== t25) {
    t26 = {
      startTextFieldProperties: t12,
      startPopoverProperties: t14,
      startTopAppBarProperties: t17,
      startPopoverSearchFieldProperties: t23,
      startItemsProperties: t24,
      startHistoryItemsProperties: t25
    };
    $[45] = t12;
    $[46] = t14;
    $[47] = t17;
    $[48] = t23;
    $[49] = t24;
    $[50] = t25;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  return t26;
};